'use strict';
import * as tools from './tools.js';

window.$ = window.jQuery = require('jquery');
window.Popper = require('@popperjs/core');
window.bootstrap = require('bootstrap');

import lazyframe from "lazyframe";
lazyframe(".lazyframe", {
    autoplay: true,
});

import Swiper, {Autoplay, Navigation, Pagination} from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const swiper = new Swiper('.swiper__full', {
    modules: [Navigation, Pagination, Autoplay],
    autoplay : {
        delay: 10000,
    },
    slidesPerView: 1,
    navigation : {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    on: {
        init: function () {
            let headerHeight = document.querySelector('header').offsetHeight;
            this.el.style.height = (innerHeight - headerHeight) + 'px';
            tools.pauseSliderVideos(this);
            tools.playSliderVideos(this);
        },
        transitionStart: function(){
            tools.pauseSliderVideos(this);
        },
        transitionEnd: function(){
            tools.playSliderVideos(this);
        },
    },
});

//Checkout
let checkout = document.getElementById('checkout');
if(checkout !== null) {
    //Selector de imagen segun tipo de producto
    let checkoutOption = checkout.querySelectorAll('.accordion-button'),
        radios = checkout.querySelectorAll('[type="radio"]'),
        imgContainer = checkout.querySelector('.image');
    checkoutOption.forEach((element) => {
        tools.hideShownSusbscriptionButton(element);
        element.addEventListener('click',function (e){
            let inputRadioPrice =  e.target.querySelector('.priceRadio'),
                inputRadioOption =  e.target.querySelector('.optionRadio'),
                isChecked = inputRadioPrice.checked && inputRadioOption.checked,
                image = e.target.dataset.image,
                alt = e.target.dataset.alt;
            radios.forEach((element2) => {
                element2.checked = false;
            })
            if(!isChecked){
                let img = imgContainer.querySelector('img');
                inputRadioPrice.checked = true;
                inputRadioOption.checked = true;
                tools.hideShownSusbscriptionButton(e.target);
                if(image) {
                    if(img !== null) {
                        img.setAttribute('src',image);
                        img.setAttribute('alt',alt);
                    } else {
                         imgContainer.innerHTML = `<img src="${image}" alt="${alt}" />`;
                    }
                }
            }
            else{
                inputRadioPrice.checked = false;
                inputRadioOption.checked = false;
                tools.hideShownSusbscriptionButton(e.target);
            }
        })
    })

    //Selector de provincia para España y campo de texto para el resto + cetelem solo para España como país de facturación (aunque miramos en ambas por si marca misma una que otra)
    let selectCountries = document.getElementById('pais'),
        fieldProvinces = document.getElementById('provincia'),
        containerHtmlSelectProvinces = document.querySelector('.base-select-provinces'),
        btnPaymentCetelem = document.querySelector('.btn-payment-cetelem'),
        cetelemCalculator = document.getElementById('eCalculadoraCetelemDiv');
    if(selectCountries !== null && fieldProvinces !== null && containerHtmlSelectProvinces !== null) {
        let country = selectCountries.options[selectCountries.selectedIndex].getAttribute('rel');
        tools.selectInputProvinces(country, fieldProvinces, containerHtmlSelectProvinces.innerHTML);
        if(btnPaymentCetelem !== null) {
            tools.hideShowBtnCetelem(country, btnPaymentCetelem, cetelemCalculator);
        }
        selectCountries.addEventListener('change', () => {
            let country = selectCountries.options[selectCountries.selectedIndex].getAttribute('rel');
            fieldProvinces = document.getElementById('provincia')
            tools.selectInputProvinces(country, fieldProvinces, containerHtmlSelectProvinces.innerHTML);
            if(btnPaymentCetelem !== null) {
                tools.hideShowBtnCetelem(country, btnPaymentCetelem, cetelemCalculator);
            }
        })
    }

    let selectCountriesBilling = document.getElementById('pais_facturacion'),
        fieldProvincesBilling = document.getElementById('provincia_facturacion'),
        containerHtmlSelectProvincesBilling = document.querySelector('.base-select-billing-provinces');
    if(selectCountriesBilling !== null && fieldProvincesBilling !== null && containerHtmlSelectProvincesBilling !== null) {
        let country = selectCountriesBilling.options[selectCountriesBilling.selectedIndex].getAttribute('rel');
        tools.selectInputProvinces(country, fieldProvincesBilling, containerHtmlSelectProvincesBilling.innerHTML);
        if(btnPaymentCetelem !== null) {
            tools.hideShowBtnCetelem(country, btnPaymentCetelem, cetelemCalculator);
        }
        selectCountriesBilling.addEventListener('change', () => {
            let country = selectCountriesBilling.options[selectCountriesBilling.selectedIndex].getAttribute('rel');
            fieldProvincesBilling = document.getElementById('provincia_facturacion')
            tools.selectInputProvinces(country, fieldProvincesBilling, containerHtmlSelectProvincesBilling.innerHTML);
            if(btnPaymentCetelem !== null) {
                tools.hideShowBtnCetelem(country, btnPaymentCetelem, cetelemCalculator);
            }
        })
    }

    //Direccion de facturacion
    let checkSameAddresses = document.getElementById('same_addresses'),
        billingAddress = document.getElementById('billing-address');
    if(checkSameAddresses !== null && billingAddress !== null) {
        tools.showHideBillingAddress(checkSameAddresses, billingAddress);
        if(selectCountriesBilling !== null && btnPaymentCetelem !== null) {
            let country = selectCountriesBilling.options[selectCountriesBilling.selectedIndex].getAttribute('rel');
            tools.hideShowBtnCetelem(country, btnPaymentCetelem, cetelemCalculator);
        }
        checkSameAddresses.addEventListener('click',() => {
            tools.showHideBillingAddress(checkSameAddresses, billingAddress);
            if(selectCountriesBilling !== null && btnPaymentCetelem !== null) {
                let country = selectCountriesBilling.options[selectCountriesBilling.selectedIndex].getAttribute('rel');
                tools.hideShowBtnCetelem(country, btnPaymentCetelem, cetelemCalculator);
            }
        })
    }

    //Ayuda número de serie
    let inputSerialNumber = document.getElementById('numero_serie'),
        helpSerialNUmber = document.querySelector('.help-serial-number');
    if(inputSerialNumber !== null && helpSerialNUmber !== null) {
        inputSerialNumber.addEventListener('focus',() => {
            helpSerialNUmber.classList.remove('d-none');
        })
        inputSerialNumber.addEventListener('blur',() => {
            helpSerialNUmber.classList.add('d-none');
        })
    }

}

//Ayuda de input serial number
let inputSerialNumber = document.getElementById('numero_serie'),
    helpSerialNUmber = document.querySelector('.help-serial-number');
if(inputSerialNumber !== null && helpSerialNUmber !== null) {
    inputSerialNumber.addEventListener('focus',() => {
        helpSerialNUmber.classList.remove('d-none');
    })
    inputSerialNumber.addEventListener('blur',() => {
        helpSerialNUmber.classList.add('d-none');
    })
}

